import React, {} from "react";
import { Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

import '../../css/main.css';

const ConfirmDeleteModal = ({ open, onClose, onNo, onYes, item }) => {

    const [t, ] = useTranslation('global');

    return (
        <div className="confirm-del-wrapper">
        <Modal 
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-del-modal-title"
            aria-describedby="confirm-del-modal-desc"
        >
            <div className="confirm-del-modal-container">
                <h2 id="confirm-del-modal-title">{t('areYouSure')}</h2>
                <div id="confirm-del-modal-desc">
                    <p>{`${t('doYouReallyWantToDelete')} ${item}?`}</p>
                    <p>{t('cannotBeUndone')}</p>
                </div>

                <div className="confirm-del-buttons">
                    <button className="confirm-cancel-button" onClick={onNo}>{t('cancel')}</button>
                    <button className="confirm-delete-button" onClick={onYes}>{t('delete')}</button>
                </div>
                
            </div>
        </Modal>
        </div>
        
    );
}

export default ConfirmDeleteModal;